import {
  Text,
  Heading,
  Flex,
  Divider,
  Avatar,
  Icon,
  Link,
  Button,
} from "@chakra-ui/react";
import { FaEnvelope, FaPhone } from "react-icons/fa";
import avatar from "./../../assets/images/3390-bg-white-square-1024-fb.jpeg";
import SocialIcons from "../social-icons/SocialIcons";

const FooterRight = (): JSX.Element => {
  return (
    <Flex direction={"column"} alignItems={"center"} gap={3}>
      <Avatar
        marginBottom={3}
        size={"2xl"}
        name={"Manish Parui"}
        src={avatar}
      />
      <Heading size={"lg"} fontWeight={"bold"}>
        Manish Parui
      </Heading>

      <Button
        as={Link}
        variant={"link"}
        href="tel:+919804307030"
        color={"neonDefault"}
        gap={3}
      >
        <Icon as={FaPhone} fontSize={"0.75rem"} />
        <Text>+91 9804307030</Text>
      </Button>

      <Button
        as={Link}
        variant={"link"}
        href="mailto:manishparui@hotmail.com"
        color={"neonDefault"}
        gap={3}
      >
        <Icon as={FaEnvelope} fontSize={"0.75rem"} />
        <Text>manishparui@hotmail.com</Text>
      </Button>

      <Divider marginY={3} width={"50%"} borderColor={"gray.600"} />

      <SocialIcons />
    </Flex>
  );
};

export default FooterRight;
